<template>
  <v-container>
    <div class="containerStyle" v-if="loader">
      <img id="loader" class="zoom" :src="img2" />
    </div>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11></v-flex>
    </v-layout>
    <v-layout row>
      <v-flex class="containerStyle2" md10 lg10 xs12 sm11 v-if="typeEstrategico == '1' ">
        <v-layout>
          <v-flex md12 lg12 xs12 sm12>
            <h4 class="pull">{{tipodimension}}</h4>
          </v-flex>
        </v-layout>

        <v-layout v-if="step1">
          <v-flex md12 lg12 xs12 sm12>
            <table class="table table-striped header-fixed">
              <thead>
                <tr>
                  <th
                    style="text-align: left"
                    :class="header.size"
                    v-for="(header,index) in headers"
                    :key="index"
                  >{{header.text}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in evaluaciones" :key="index">
                  <td style="text-align:left " :class="headers[0].size">{{index+1}}</td>
                  <td style="text-align:left " :class="headers[1].size">{{item.criterioEvaluacion}}</td>
                  <td style="text-align:left " :class="headers[2].size">{{item.calificacion}}</td>
                  <td style="text-align:left " :class="headers[3].size">{{item.evidencia}}</td>

                  <td :class="headers[4].size">
                    <v-icon small class="mr-2" @click="openEditEvaluaciones(item,index)">edit</v-icon>
                    <v-icon small class="mr-2" @click="viewDocument(item)">add</v-icon>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-flex>
        </v-layout>

        <v-layout v-if="!step1">
          <v-flex md12 lg12 xs12 sm12>
            <table id="table2" class="table table-striped header-fixed">
              <thead>
                <tr>
                  <th style class="col-md-10 col-lg-10 col-sm-10 col-xs-10">Fortalezas</th>
                  <th style="text-align:left " class="col-md-1 col-lg-1 col-sm-1 col-xs-1">Editar</th>
                  <th style="text-align:left " class="col-md-1 col-lg-1 col-sm-1 col-xs-1">Borrar</th>
                </tr>
              </thead>
              <tbody class="table2">
                <tr v-for="(item,index) in fortalezas" :key="index">
                  <td
                    style="text-align:left "
                    class="col-md-10 col-lg-10 col-sm-10 col-xs-10"
                  >{{item.descripcion}}</td>
                  <td class="col-md-1 col-lg-1 col-sm-1 col-xs-1">
                    <v-icon
                      :disabled="($session.getAll().puedeEditar != true)"
                      small
                      class="mr-2"
                      @click="openEditFortaleza(item,index)"
                    >edit</v-icon>
                  </td>
                  <td class="col-md-1 col-lg-1 col-sm-1 col-xs-1">
                    <v-icon
                      :disabled="($session.getAll().puedeEditar != true)"
                      small
                      class="mr-2"
                      @click="deleteFD(item)"
                    >delete</v-icon>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-flex>
        </v-layout>

        <v-layout v-if="!step1">
          <v-flex md12 lg12 xs12 sm12>
            <table class="table table-striped header-fixed table2">
              <thead>
                <tr>
                  <th style class="col-md-10 col-lg-10 col-sm-10 col-xs-10">Debilidades</th>
                  <th style="text-align:left " class="col-md-1 col-lg-1 col-sm-1 col-xs-1">Editar</th>
                  <th style="text-align:left " class="col-md-1 col-lg-1 col-sm-1 col-xs-1">Borrar</th>
                </tr>
              </thead>
              <tbody class="table2">
                <tr v-for="(item,index) in debilidades" :key="index">
                  <td
                    style="text-align:left "
                    class="col-md-10 col-lg-10 col-sm-10 col0-xs-10"
                  >{{item.descripcion}}</td>
                  <td class="col-md-1 col-lg-1 col-sm-1 col-xs-1">
                    <v-icon
                      :disabled="($session.getAll().puedeEditar != true)"
                      small
                      class="mr-2"
                      @click="openEditDebilidad(item,index)"
                    >edit</v-icon>
                  </td>
                  <td class="col-md-1 col-lg-1 col-sm-1 col-xs-1">
                    <v-icon
                      :disabled="($session.getAll().puedeEditar != true)"
                      small
                      class="mr-2"
                      @click="deleteFD(item)"
                    >delete</v-icon>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-flex>
        </v-layout>

        <v-layout v-if="step1">
          <v-flex md12 lg12 xs12 sm12>
            <v-card class="pull v-card-new">
              <h5 class="pull" style="color:white">Síntesis Evaluativa</h5>

              <p class="text-vision">{{this.evaluacionGral}}</p>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-btn color="#394049" v-show="step1" @click="cambio2()">Fortalezas y debilidades</v-btn>
      <v-btn color="#394049" v-show="!step1" @click="cambio1()">Regresar</v-btn>
      <v-btn color="#394049" v-show="!step1" @click="opencreateFortaleza()">Agregar Fortaleza</v-btn>
      <v-btn color="#394049" v-show="!step1" @click="opencreateDebilidad()">Agregar Debilidad</v-btn>
      <v-btn color="#394049" v-show="step1" @click="dialog = true">Editar Síntesis Evaluativa</v-btn>
   <!--    <v-btn
        v-if="this.$session.getAll().userType == 'postgradodca'"
        color="#394049"
        @click="openAprobacion"
      >Aprobación DCa</v-btn>
      <v-btn
        v-if="this.$session.getAll().userType != 'postgradodca'"
        color="#394049"
        @click="openViewAprobacion()"
      >Estado de aprobación DCA</v-btn>

      <v-btn
        v-if="this.$session.getAll().userType == 'postgrado'"
        color="#394049"
        @click="openAprobacionPost"
      >Aprobación Programa</v-btn>
      <v-btn
        v-if="this.$session.getAll().userType != 'postgrado'"
        color="#394049"
        @click="openViewAprobacionPost()"
      >Estado de aprobación Programa</v-btn> -->
    </v-layout>
    <v-layout>
      <v-dialog v-model="dialog" width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Editar síntesis evaluativa</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="comment">Síntesis Evaluativa</label>
                <textarea
                  v-model="dimension.evaluacionGeneral"
                  type="text"
                  rows="10"
                  class="form-control"
                  id="comment"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat="flat" @click="dialog = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="updateGeneral()">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout>
      <v-dialog v-model="edit" width="600px">
        <v-card>
          <v-card-title>
            <span class="headline" v-if="!create">Editar evaluación</span>
            <span class="headline" v-if="create">Crear evaluación</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Evaluación</label>
                <select class="form-control" id="sel1" v-model="evaluacion.calificacion">
                  <option selected disabled>-Selecciona una opción-</option>
                  <option value="Insuficiente">Insuficiente</option>
                  <option value="Suficiente">Suficiente</option>
                  <option value="Satisfactorio">Satisfactorio</option>
                  <option value="Sobresaliente">Sobresaliente</option>
                  <option value="No Aplica">No Aplica</option>
                </select>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Evidencia</label>
                <textarea
                  v-model="evaluacion.evidencia"
                  type="text"
                  rows="6"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat="flat" @click="edit = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="!create" @click="editEvaluacion()">Guardar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="create" @click="createFortaleza()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-layout>
        <v-dialog v-model="editFortaleza" width="600px">
          <v-card>
            <v-card-title>
              <span class="headline" v-if="!create">Editar Fortaleza</span>
              <span class="headline" v-if="create">Crear Fortaleza</span>
            </v-card-title>
            <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
              <v-layout row>
                <v-flex md12 lg12 xs12 sm12>
                  <label for="usr">Fortaleza</label>
                  <textarea
                    v-model="fortaleza.descripcion"
                    type="text"
                    rows="6"
                    class="form-control"
                    id="usr"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat="flat" @click="editFortaleza = false">Cerrar</v-btn>
              <v-btn color="#394049" flat="flat" v-if="!create" @click="editFortalezaF()">Guardar</v-btn>
              <v-btn color="#394049" flat="flat" v-if="create" @click="createFortaleza()">Crear</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout>
        <v-dialog v-model="editDebilidad" width="600px">
          <v-card>
            <v-card-title>
              <span class="headline" v-if="!create">Editar Debilidad</span>
              <span class="headline" v-if="create">Crear Debilidad</span>
            </v-card-title>
            <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
              <v-layout row>
                <v-flex md12 lg12 xs12 sm12>
                  <label for="usr">Debilidad</label>
                  <textarea
                    v-model="debilidad.descripcion"
                    type="text"
                    rows="6"
                    class="form-control"
                    id="usr"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat="flat" @click="editDebilidad = false">Cerrar</v-btn>
              <v-btn color="#394049" flat="flat" v-if="!create" @click="editDebilidadF()">Guardar</v-btn>
              <v-btn color="#394049" flat="flat" v-if="create" @click="createDebilidad()">Crear</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-layout>
    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="aprobacion" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-dialog">
            <v-card-title v-if="create">
              <span class="headline">¿Desea aprobar la etapa?</span>
            </v-card-title>
            <v-card-title v-if="!create">
              <span class="headline">Estado de aprobación</span>
            </v-card-title>
            <v-layout v-if="!create">
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <h4 v-if="this.etapa.etapa2Dca">Aprobado por DCA</h4>
                <h4 v-if="!this.etapa.etapa2Dca">Aún no hay aprobación por parte de DCA</h4>
                <h4>{{etapa.fechaEtapa2}}</h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <label for="usr">Observación</label>
                <textarea
                  v-model="obsEtapa"
                  type="text"
                  rows="3"
                  class="form-control"
                  id="usr"
                  :disabled="this.$session.getAll().userType != 'postgradodca'"
                />
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat="flat" @click="aprobacion = false">Cerrar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgradodca'"
                color="red"
                flat="flat"
                @click="checkPro(false)"
              >desaprobar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgradodca'"
                color="#394049"
                flat="flat"
                @click="checkPro(true)"
              >aprobar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="aprobacionPost" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-dialog">
            <v-card-title v-if="create">
              <span class="headline">¿Desea aprobar la etapa?</span>
            </v-card-title>
            <v-card-title v-if="!create">
              <span class="headline">Estado de aprobación</span>
            </v-card-title>
            <v-layout v-if="!create">
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <h4 v-if="this.etapa.etapa3Dca">Aprobado por Programa</h4>
                <h4 v-if="!this.etapa.etapa3Dca">Aún no hay aprobación por parte del programa</h4>
                <h4>{{etapa.fechaEtapa2Gral}}</h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <label for="usr">Observación</label>
                <textarea
                  v-model="obsEtapaPost"
                  type="text"
                  rows="3"
                  class="form-control"
                  id="usr"
                  :disabled="this.$session.getAll().userType != 'postgrado'"
                />
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat="flat" @click="aprobacionPost = false">Cerrar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgrado'"
                color="red"
                flat="flat"
                @click="checkPrograma(false)"
              >desaprobar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgrado'"
                color="#394049"
                flat="flat"
                @click="checkPrograma(true)"
              >aprobar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import img1 from "../../../assets/BANNER_6.png";
import img3 from "../../../assets/nuevaasistenciadca.png";
import img2 from "../../../assets/LOGO USACH.png";


export default {
  data() {
    return {
      img2: img2,
      loader: true,
      obsEtapaPost: "",
      aprobacionPost: "",
      nEtapa: 2,
      etapa: "",
      obsEtapa: "",
      create: "",
      aprobacion: "",
      editFortaleza: false,
      editDebilidad: false,
      step1: true,
      dimension: "",
      tipodimension: " ",

      evaluacionGral: "",
      fortalezas: "",
      fortaleza: "",
      debilidades: "",
      debilidad: "",
      evaluaciones: "",
      img3: img3,
      asistencia: false,

      create: false,
      edit: false,
      index: "",
      dialog: false,
      evaluacion: {
        ambito: "",
        nivel: "",
        evaluacion: "",
        queHaremos: []
      },

      headers: [
        {
          text: "Id",
          value: "name",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        },
        {
          text: "a",
          value: "name",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3"
        },

        {
          text: "Evaluación",
          value: "muy desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3"
        },
        {
          text: "Evidencia",
          value: "desacuerdo",
          size: "col-md-4 col-lg-4 col-sm-4 col-xs-4"
        },

        {
          text: "Editar",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        }
      ],
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      filesDge: "",
      img1: img1,

      right: null
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      this.loader = true
      this.initComponent();
    }
  },

  created() {
    this.initComponent();
  },
  methods: {
    viewDocument(item) {
      this.$router.push({ name: "evidenciaCriteriosDoc", params: { id: item.id } });
    },
    openAprobacion() {
      this.aprobacion = true;
      this.create = true;
    },
    openViewAprobacion() {
      this.aprobacion = true;
      this.create = false;
    },

    openAprobacionPost() {
      this.aprobacionPost = true;
      this.create = true;
    },
    openViewAprobacionPost() {
      this.aprobacionPost = true;
      this.create = false;
    },

    checkPrograma(booleanValue) {
      this.aprobacionPost = false;
      this.etapa["comentarioEtapa" + this.nEtapa + "Gral"] = this.obsEtapaPost;
      this.etapa["etapa" + this.nEtapa + "Otro"] = booleanValue;
      var tipo = "";
      if (booleanValue) {
        tipo = "aprobada";
      } else {
        tipo = "desaprobada";
      }
      //console.log(this.nEtapa);
      axios
        .patch(
          process.env.ROOT_API +
            "/etapa/updateEtapaGral?etapaNum=" +
            this.nEtapa,
          this.etapa,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initObservacionGral();
          alert("Etapa " + this.nEtapa + " ha sido " + tipo);
        })
        .catch(error => {
          console.error(error);
          this.initObservacionGral();
          alert("Error:" + error);
        });
    },

    checkPro(booleanValue) {
      this.aprobacion = false;
      this.etapa["comentarioEtapa" + this.nEtapa] = this.obsEtapa;
      this.etapa["etapa" + this.nEtapa + "Dca"] = booleanValue;
      var tipo = "";
      if (booleanValue) {
        tipo = "aprobada";
      } else {
        tipo = "desaprobada";
      }
      //console.log(this.nEtapa);
      axios
        .patch(
          process.env.ROOT_API +
            "/etapa/updateEtapaDca?etapaNum=" +
            this.nEtapa,
          this.etapa,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initObservacionGral();
          alert("Etapa " + this.nEtapa + " ha sido " + tipo);
        })
        .catch(error => {
          console.error(error);
          this.initObservacionGral();
          alert("Error:" + error);
        });
    },
    redirect(index) {
      this.typeEstrategico = index;
    },
    sendDge() {
      this.asistencia = false;
      alert("Tus inquietudes han sido enviadas, pronto te contactaremos.");
    },

    initComponent() {
      this.getCriterio(this.$route.params.id);
      this.initObservacionGral();
    },

    initObservacionGral() {
      axios
        .get(
          process.env.ROOT_API +
            "/etapa/etapaUsuario?idPostgrado=" +
            this.$session.getAll().ccData.id,
          this.auth
        )
        .then(response => {
          //console.log("ANEXOS");
          //console.log(response.data);
          this.obsEtapa = response.data["comentarioEtapa" + this.nEtapa];
          this.obsEtapaPost =
            response.data["comentarioEtapa" + this.nEtapa + "Gral"];
          this.etapa = response.data;
          //console.log(this.obsEtapa);
        })
        .catch(error => {
          //console.log("ERROR ANEXOS");
          console.error(error);
          this.showAlert("error", error.response.data);
        });
    },

    getCriterio(idDimension) {
      axios
        .get(
          process.env.ROOT_API +
            "/dimension/getAllByDimensionAndCarrera?idCarrera=" +
            this.$session.getAll().ccData.id +
            "&idDimension=" +
            idDimension,
          this.auth
        )
        .then(response => {
          //console.log("get evaluaciones");
          //console.log(response.data);
          this.dimension = response.data;
          this.evaluacionGral = this.dimension.evaluacionGeneral;
          this.tipodimension = this.dimension.nombre;
          this.headers[1].text = this.tipodimension;
          this.getEvaluaciones(this.dimension.id);
          
        })
        .catch(error => {
          console.error(error);
        });
    },

    getEvaluaciones(idDimension) {
      axios
        .get(
          process.env.ROOT_API +
            "/evaluacion/getAllByCriterioAndCarrera?idCriterio=" +
            this.dimension.id,
          this.auth
        )
        .then(response => {
          //console.log("get evaluaciones");
          //console.log(response.data);
          this.evaluaciones = response.data;
          this.getFyd();
          
        })
        .catch(error => {
          console.error(error);
        });
    },

    deleteFD(item) {
      //console.log(item.id);
      axios
        .delete(
          process.env.ROOT_API + "/fyd/delete?idFyD=" + item.id,
          this.auth
        )
        .then(response => {
          this.getFyd();
          alert(response.data);
        })
        .catch(error => {
          console.error(error);
        });
    },

    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDge.dge[index]["path"]);
      var nameFile = this.filesDge.dge[index]["name"];
      //console.log(nameFile);
      axios
        .get(
          "http://localhost:8089/uploadFileDcaEtc/downloadFile?dir=" + pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    updateGeneral(propuesta) {
      this.dialog = false;
      axios
        .post(
          process.env.ROOT_API + "/dimension/updateDimension",
          this.dimension,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.initComponent();
          alert("Síntesis Evaluativa editada");
        })
        .catch(error => {
          console.error(error);
          this.initComponent();
          alert("Error:" + error);
        });
    },

    openEditEvaluaciones(evaluacion, index) {
      this.create = false;
      this.edit = true;
      this.index = index;
      this.evaluacion = evaluacion;
    },

    editEvaluacion() {
      this.edit = false;
      axios
        .post(
          process.env.ROOT_API + "/evaluacion/updateEvaluacion",
          this.evaluacion,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.initComponent();
          alert("Evaluación editada");
        })
        .catch(error => {
          console.error(error);
          this.initComponent();
          alert("Error:" + error);
        });
    },

    openEditFortaleza(fortaleza, index) {
      this.create = false;
      this.editFortaleza = true;
      this.index = index;
      this.fortaleza = fortaleza;
    },

    openEditDebilidad(debilidad, index) {
      this.create = false;
      this.editDebilidad = true;
      this.index = index;
      this.debilidad = debilidad;
    },

    editFortalezaF() {
      this.editFortaleza = false;
      axios
        .post(
          process.env.ROOT_API + "/fyd/updateFortalezaDebilidad",
          this.fortaleza,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.getFyd();
          alert("Fortaleza editada");
        })
        .catch(error => {
          console.error(error);
          this.getFyd();
          alert("Error:" + error);
        });
    },
    editDebilidadF() {
      this.editDebilidad = false;
      axios
        .post(
          process.env.ROOT_API + "/fyd/updateFortalezaDebilidad",
          this.debilidad,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.getFyd();
          alert("Debilidad editada");
        })
        .catch(error => {
          console.error(error);
          this.getFyd();
          alert("Error:" + error);
        });
    },

    opencreateDebilidad() {
      this.create = true;
      this.editDebilidad = true;
      this.debilidad = {
        descripcion: "",
        tipo: "Debilidad"
      };
    },

    opencreateFortaleza() {
      this.create = true;
      this.editFortaleza = true;
      this.fortaleza = {
        descripcion: "",
        tipo: "Fortaleza"
      };
    },

    createFortaleza() {
      this.editFortaleza = false;
      axios
        .post(
          process.env.ROOT_API +
            "/fyd/createFortalezaDebilidadDimension?idDimension=" +
            this.dimension.id,
          this.fortaleza,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.getFyd();
          alert("Fortaleza Agregada");
        })
        .catch(error => {
          console.error(error);
          this.getFyd();
          alert("Error:" + error);
        });
    },

    createDebilidad() {
      this.editDebilidad = false;
      axios
        .post(
          process.env.ROOT_API +
            "/fyd/createFortalezaDebilidadDimension?idDimension=" +
            this.dimension.id,
          this.debilidad,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.getFyd();
          alert("Debilidad Agregada");
        })
        .catch(error => {
          console.error(error);
          this.getFyd();
          alert("Error:" + error);
        });
    },

    getFyd() {
      axios
        .get(
          process.env.ROOT_API +
            "/fyd/getAllByDimension?idDimension=" +
            this.dimension.id,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.fortalezas = response.data[0];
          this.debilidades = response.data[1];
          this.loader=false
        })
        .catch(error => {
          console.error(error);
          this.loader=false
          alert("Error:" + error);
        });
    },

    replaceT(texto) {
      var newTexto = texto.replace(/\n/g, "<br />");
      //console.log(newTexto);
      return newTexto;
    },

    cambio1() {
      this.step1 = true;
    },

    /* getFyd() {
      axios
        .get(
          process.env.ROOT_API +
            "/fyd/getAllByDimension?idDimension=" +
            this.dimension.id,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.fortalezas = response.data[0];
          this.debilidades = response.data[1];
        })
        .catch(error => {
          console.error(error);
          alert("Error:" + error);
        });
    }, */
    cambio2() {
      this.step1 = false;
      this.getFyd();
    }
  }
};
</script>


<style scoped>
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 150px !important;
}

.v-card-new {
  margin-bottom: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #4376a1 !important;
  height: 150px !important;
  overflow-y: auto;
}

.v-card {
  overflow-y: auto;
  height: auto;
}

.td-color {
  background: #4376a1;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}
.text-vision {
  color: white;
  font-size: 12px;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 200px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 11px;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>


// WEBPACK FOOTER //
// src/components/dca/evaluacion/D1e.vue